class EmailSignup {
	constructor(node) {
		this.node = node;
		if (!this.node) {
			return;
		}
		this.emailField = node.querySelector('input[name="EmailAddress"]');
		this.firstNameField = node.querySelector('input[name="FirstName"]');
		this.lastNameField = node.querySelector('input[name="LastName"]');
		this.countryField = node.querySelector('select[name="Country"]');

		node.addEventListener('submit', this.handleFormSubmit.bind(this));


	};


	isEmailValid = (email) => {
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	};

	isRequired = value => value === '' ? false : true;

	showError = (input, message) => {
		// get the form-field element
		const formField = input.parentElement;
		// add the error class
		formField.classList.remove('success');
		formField.classList.add('error');

		// show the error message
		const error = formField.querySelector('small');
		error.textContent = message;
	};

	showSuccess = (input) => {
		// get the form-field element
		const formField = input.parentElement;

		// remove the error class
		formField.classList.remove('error');
		formField.classList.add('success');

		// hide the error message
		const error = formField.querySelector('small');
		error.textContent = '';
	}

	checkEmail = () => {
		let valid = false;
		const email = this.emailField.value.trim();
		if (!this.isRequired(email)) {
			this.showError(this.emailField, 'Email cannot be blank.');
		} else if (!this.isEmailValid(email)) {
			this.showError(this.emailField, 'Email is not valid. Please check the address.')
		} else {
			this.showSuccess(this.emailField);
			valid = true;
		}
		return valid;
	};

	checkFirstName = () => {
		let valid = false;
		const firstName = this.firstNameField.value.trim();
		if (!this.isRequired(firstName)) {
			this.showError(this.firstNameField, 'First name cannot be blank.');
		}else {
			this.showSuccess(this.firstNameField);
			valid = true;
		}
		return valid;
	};

	checkLastName = () => {
		let valid = false;
		const lastName = this.lastNameField.value.trim();
		if (!this.isRequired(lastName)) {
			this.showError(this.lastNameField, 'Last name cannot be blank.');
		} else {
			this.showSuccess(this.lastNameField);
			valid = true;
		}
		return valid;
	};

	checkCountry = () => {
		let valid = false;
		const country = this.countryField.value.trim();
		if (!this.isRequired(country)) {
			this.showError(this.countryField, 'Please select a country.');
		} else {
			this.showSuccess(this.countryField);
			valid = true;
		}
		return valid;
	};

	handleFormSubmit (event) {
		event.preventDefault();

		// validate fields
		let isEmailValid = this.checkEmail(),
			isFirstNameValid = this.checkFirstName(),
			isLastNameValid = this.checkLastName(),
			isCountryValid = this.checkCountry();
		let isFormValid = isEmailValid &&
			isFirstNameValid &&
			isLastNameValid &&
			isCountryValid;

		let firstError = event.target.querySelector('.error');
		if(firstError){
			firstError.querySelector('.email-signup__field').focus();
		}

		if (isFormValid) {
		const formData = new FormData(event.target);
		const formJSON = Object.fromEntries(formData.entries());
		const errorMsg = event.target.querySelector('.email-signup--error');
		let submitBtn = event.submitter;

		submitBtn.value ='Processing';
		submitBtn.disabled = true;
		fetch(event.target.action, {
			method: 'POST',
			body: JSON.stringify(formJSON),
			headers: {
				'Content-type': 'application/json; charset=UTF-8',
			}
		}).then(response => {
			if (response.ok) {
				return response.json();
			} else if(response.status === 500) {
				throw new Error('There was a problem with the server. Please try again later.');
			}
			else {
				throw new Error('There was a problem submitting the form.');
			}
		}).then(data => {
			if (data.message.includes('Contact already exists')) {
				submitBtn.value = 'Subscribe';
				submitBtn.disabled = false;
				errorMsg.classList.add('has-error');
				errorMsg.innerHTML = `<p>Thank you for your submission. This email address is already present in our system. Please check your inbox to finish the subscription process or to access your personal preference center to make updates.</p>`;
			}else {
				event.target.insertAdjacentHTML('beforebegin', `<p class="email-signup--success">Thank you. To complete the subscription process, please click the link in the email we just sent you.</p>`);
				event.target.style.display = 'none';
			}

		}).catch(error => {
			console.log(error);
			submitBtn.value = 'Subscribe';
			submitBtn.disabled = false;
			errorMsg.classList.add('has-error');
			errorMsg.innerHTML = `<p>There was a problem submitting this form. Please contact <a href="mailto:office-of-communications@fordfoundation.org">office-of-communications@fordfoundation.org</a> for assistance.</p>`;

		});
	}
	}
}

EmailSignup.instances = Array.from(document.querySelectorAll('.email-signup')).map(n => new EmailSignup(n));

export default EmailSignup;
